module.exports = __webpack_public_path__ + "img/shaft.8db4a939.jpg";